import { useEffect, useState } from 'react';
import './App.css';

const serviceUrl = 'https://service.filmountain.io';

const coins = [
  {
    key: 'filecoin',
    name: 'Filecoin',
    koreanName: '파일코인',
    symbol: 'FIL',
    logo: '/images/filecoin-logo.png',
    color: '#0090FF',
    accent: '#48CAE4',
    guideUrl: `${serviceUrl}/filecoin-guide`,
    updatedAt: '2025.12.02',
    summary:
      '분산형 스토리지 네트워크로, 여유 저장 공간을 공유하고 검증 가능한 방식으로 데이터를 보관하는 블록체인 기반 플랫폼입니다.',
    points: [
      'IPFS 기반의 탈중앙화 클라우드 스토리지',
      'Proof of Replication으로 데이터 저장 상태 증명',
      'Proof of Spacetime으로 약정 기간 보관 여부 검증',
      '스토리지·검색 시장을 통한 데이터 저장 비용 효율화',
    ],
    metrics: [
      ['Network', 'Storage'],
      ['Mainnet', '2020.10'],
      ['Asset', 'FIL'],
    ],
  },
  {
    key: 'aethir',
    name: 'Aethir',
    koreanName: '에이셔',
    symbol: 'ATH',
    logo: '/images/aethir-logo.png',
    color: '#CCFF00',
    accent: '#E6FF66',
    guideUrl: `${serviceUrl}/aethir-guide`,
    updatedAt: '2025.12.02',
    summary:
      '엔터프라이즈급 GPU 자원을 집계해 AI와 클라우드 게이밍을 위한 분산형 클라우드 인프라를 제공하는 플랫폼입니다.',
    points: [
      '전 세계 유휴 GPU 자원 집계 및 최적화',
      'AI 모델 학습·추론을 위한 고성능 컴퓨팅 지원',
      '초저지연 클라우드 게이밍 인프라',
      '탈중앙화 구조를 통한 비용 절감과 자원 효율화',
    ],
    metrics: [
      ['Network', 'GPU Cloud'],
      ['Launch', '2024.06'],
      ['Asset', 'ATH'],
    ],
  },
];

const processSteps = [
  {
    number: '01',
    title: '네트워크 선택',
    description: 'Filecoin 스토리지와 Aethir GPU 인프라 중 운용 목적에 맞는 자산군을 선택합니다.',
  },
  {
    number: '02',
    title: '유동성 운용',
    description: '예치, 잠긴 유동성, 리워드 흐름을 한 화면에서 확인할 수 있도록 설계합니다.',
  },
  {
    number: '03',
    title: '검증 정보 확인',
    description: '주요 내용 설명서의 기술 구조, 보상 방식, 위험 고지를 투자 전 확인 흐름에 배치합니다.',
  },
  {
    number: '04',
    title: '포트폴리오 관리',
    description: '서비스 대시보드로 이어지는 동선을 통해 자산 상태와 입출금 흐름을 계속 추적합니다.',
  },
];

const faqGroups = [
  {
    id: 'service',
    title: '서비스 이용',
    items: [
      {
        id: 'service-1',
        question: 'FileMountain은 어떤 서비스인가요?',
        answer:
          'FileMountain은 Filecoin 분산 스토리지와 Aethir GPU 클라우드 인프라를 한 화면에서 이해하고 관리할 수 있도록 정리한 디지털 자산 인프라 서비스입니다.',
      },
      {
        id: 'service-2',
        question: '메인 페이지와 관리자 사이트는 어떻게 다른가요?',
        answer:
          '메인 페이지는 네트워크 소개, 가이드, 이용 흐름, 리스크 고지를 안내하는 공개 페이지입니다. 실제 자산 현황 확인이나 운영 관리는 관리자 사이트에서 진행합니다.',
      },
      {
        id: 'service-3',
        question: '서비스 이용 전 어떤 정보를 확인해야 하나요?',
        answer:
          '각 네트워크의 기술 구조, 보상 방식, 입출금 조건, 고객확인 제도, 가상자산 거래 위험 고지를 먼저 확인한 뒤 이용해 주세요.',
      },
    ],
  },
  {
    id: 'filecoin',
    title: 'Filecoin',
    items: [
      {
        id: 'filecoin-1',
        question: 'Filecoin은 어떤 네트워크인가요?',
        answer:
          'Filecoin은 분산 스토리지 네트워크로, 저장 공간을 제공하고 검증 가능한 방식으로 데이터를 보관하는 블록체인 기반 인프라입니다.',
      },
      {
        id: 'filecoin-2',
        question: 'FIL 관련 가이드는 어디에서 볼 수 있나요?',
        answer:
          'Filecoin 상세 가이드는 메인 화면의 Filecoin 카드 또는 하단 정책 링크를 통해 확인할 수 있습니다. 네트워크 개요, 검증 방식, 보상 구조를 함께 정리했습니다.',
      },
      {
        id: 'filecoin-3',
        question: '스토리지 보상은 항상 동일한가요?',
        answer:
          '아닙니다. 네트워크 상태, 시장 가격, 수수료, 운영 조건에 따라 예상 보상과 실제 결과가 달라질 수 있습니다.',
      },
    ],
  },
  {
    id: 'aethir',
    title: 'Aethir',
    items: [
      {
        id: 'aethir-1',
        question: 'Aethir는 어떤 인프라를 제공하나요?',
        answer:
          'Aethir는 AI, 클라우드 게임, 렌더링 등에 필요한 GPU 컴퓨팅 자원을 분산형 방식으로 연결하는 GPU 클라우드 인프라 네트워크입니다.',
      },
      {
        id: 'aethir-2',
        question: 'ATH 관련 정보는 어디에서 확인하나요?',
        answer:
          'Aethir 상세 가이드에서 네트워크 개요, GPU 자원 활용 방식, 리워드 구조, 이용 시 확인해야 할 사항을 볼 수 있습니다.',
      },
      {
        id: 'aethir-3',
        question: 'GPU Cloud 수익은 보장되나요?',
        answer:
          '수익은 보장되지 않습니다. 자원 수요, 네트워크 정책, 토큰 가격, 운영 환경에 따라 변동될 수 있습니다.',
      },
    ],
  },
  {
    id: 'risk',
    title: '보안 및 리스크',
    items: [
      {
        id: 'risk-1',
        question: '왜 고객확인 절차가 필요한가요?',
        answer:
          '가상자산 서비스는 관련 법령과 내부 정책에 따라 고객확인 및 위험 평가 절차가 필요할 수 있습니다. 이는 안전한 서비스 이용과 부정 이용 방지를 위한 절차입니다.',
      },
      {
        id: 'risk-2',
        question: '입출금 전 주의할 점은 무엇인가요?',
        answer:
          '입출금 주소, 네트워크 종류, 수수료, 처리 시간을 반드시 확인해 주세요. 잘못된 네트워크나 주소로 전송하면 복구가 어려울 수 있습니다.',
      },
      {
        id: 'risk-3',
        question: '문의는 어디로 하면 되나요?',
        answer:
          '서비스 이용, 제휴, 기술 문의는 allen@zetacube.net 으로 보내 주세요. 담당자가 확인 후 안내드립니다.',
      },
    ],
  },
];

const faqCategories = [
  { id: 'all', label: '전체' },
  ...faqGroups.map((group) => ({ id: group.id, label: group.title })),
];

const footerLinks = [
  ['개인정보 처리방침', '/policy/privacy', true],
  ['이용약관', '/policy/terms'],
  ['손해배상 정책', '/policy/compensation'],
  ['고객확인제도(CDD/EDD)', '/policy/cdd-edd'],
  ['가상자산 거래 위험 고지', '/policy/risk-notice'],
  ['출금수수료 안내', '/policy/withdrawal-fee'],
  ['고객피해보상절차 및 방법', '/policy/misdeposit-guide'],
];

function Header({ currentPath, onNavigate }) {
  const handleNavigate = (event, path) => {
    event.preventDefault();
    onNavigate(path);
  };

  return (
    <header className="site-header">
      <a
        className="site-header__brand"
        href="/"
        aria-label="FilMountain home"
        onClick={(event) => handleNavigate(event, '/')}
      >
        <img src="/images/filmountain_logo_header.png" alt="FilMountain" />
      </a>

      <nav className="site-header__menu" aria-label="Primary menu">
        <a
          className={currentPath === '/faq' ? 'is-active' : undefined}
          href="/faq"
          aria-current={currentPath === '/faq' ? 'page' : undefined}
          onClick={(event) => handleNavigate(event, '/faq')}
        >
          FAQ
        </a>
      </nav>
    </header>
  );
}

function Hero() {
  return (
    <section className="hero">
      <video className="hero__video" autoPlay muted loop playsInline preload="metadata" aria-hidden="true">
        <source src="/background_image1.mp4" type="video/mp4" />
      </video>

      <div className="hero__visual" aria-hidden="true">
        <div className="hero__track hero__track--one" />
        <div className="hero__track hero__track--two" />
        <div className="hero__track hero__track--three" />
        <span className="hero__event hero__event--one" />
        <span className="hero__event hero__event--two" />
        <span className="hero__event hero__event--three" />
        <span className="hero__event hero__event--four" />
        <div className="hero__node hero__node--filecoin">
          <img src="/images/filecoin-logo.png" alt="" />
          <span>Storage</span>
        </div>
        <div className="hero__node hero__node--aethir">
          <img src="/images/aethir-logo.png" alt="" />
          <span>GPU Cloud</span>
        </div>
        <div className="hero__panel hero__panel--left">
          <span className="panel-label">Liquidity</span>
          <strong>382K FIL</strong>
          <span className="panel-line" />
        </div>
        <div className="hero__panel hero__panel--right">
          <span className="panel-label">Compute</span>
          <strong>1.18M ATH</strong>
          <span className="panel-line panel-line--lime" />
        </div>
      </div>

      <div className="hero__content">
        <span className="hero__eyebrow">FILMOUNTAIN DIGITAL ASSET INFRA</span>
        <h1>FILMOUNTAIN</h1>
        <p>
          분산 스토리지와 GPU 컴퓨팅 인프라 자산을 이해하고 운용 흐름까지 이어보는
          디지털 자산 서비스 입니다.
        </p>
        <div className="hero__actions">
          <a className="button button--primary" href={`${serviceUrl}/portfolio`}>
            대시보드로 이동
          </a>
          <a className="button button--soft" href="#networks">
            네트워크 보기
          </a>
        </div>
      </div>
    </section>
  );
}

function NetworkCard({ coin }) {
  return (
    <article className={`network-card network-card--${coin.key}`}>
      <div className="network-card__header">
        <div className="network-card__identity">
          <img src={coin.logo} alt={`${coin.name} logo`} />
          <div>
            <span>{coin.koreanName}</span>
            <h3>{coin.name}</h3>
          </div>
        </div>
        <span className="network-card__symbol">{coin.symbol}</span>
      </div>

      <p>{coin.summary}</p>

      <dl className="network-card__metrics">
        {coin.metrics.map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>

      <ul>
        {coin.points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>

      <a className="network-card__link" href={coin.guideUrl}>
        주요 내용 설명서 보기
      </a>
    </article>
  );
}

function Networks() {
  return (
    <section className="section section--networks" id="networks">
      <div className="section__heading">
        <span>SUPPORTED NETWORKS</span>
        <h2>스토리지와 컴퓨팅, 두 축으로 보는 FilMountain</h2>
        <p>
          관리자 사이트의 Filecoin·Aethir 주요 내용 설명서를 바탕으로, 사용자가 첫 화면에서
          각 네트워크의 역할과 진입 경로를 바로 파악하도록 구성했습니다.
        </p>
      </div>

      <div className="network-grid">
        {coins.map((coin) => (
          <NetworkCard coin={coin} key={coin.key} />
        ))}
      </div>
    </section>
  );
}

function GuideSummary() {
  return (
    <section className="section section--guide" id="guide">
      <div className="guide-layout">
        <div className="guide-copy">
          <span>GUIDE SNAPSHOT</span>
          <h2>투자 전 확인해야 할 기술 구조와 위험 고지</h2>
          <p>
            주요 내용 설명서는 네트워크의 개요, 핵심 기술, 보상 구조, 리스크를 순서대로
            정리합니다. 메인 페이지에서는 이 흐름을 짧게 압축해 사용자가 상세 가이드로
            자연스럽게 이동하도록 만들었습니다.
          </p>
        </div>

        <div className="guide-table" role="table" aria-label="Guide comparison">
          <div className="guide-table__row guide-table__row--head" role="row">
            <span role="columnheader">구분</span>
            <span role="columnheader">Filecoin</span>
            <span role="columnheader">Aethir</span>
          </div>
          <div className="guide-table__row" role="row">
            <span role="cell">핵심 인프라</span>
            <span role="cell">분산형 데이터 스토리지</span>
            <span role="cell">분산형 GPU 클라우드</span>
          </div>
          <div className="guide-table__row" role="row">
            <span role="cell">검증 방식</span>
            <span role="cell">PoRep, PoSt</span>
            <span role="cell">자원 집계·검증 네트워크</span>
          </div>
          <div className="guide-table__row" role="row">
            <span role="cell">수요 영역</span>
            <span role="cell">데이터 저장, 검색, IPFS</span>
            <span role="cell">AI 연산, 클라우드 게이밍</span>
          </div>
          <div className="guide-table__row" role="row">
            <span role="cell">가이드 버전</span>
            <span role="cell">v1.0 · 2025.12.02</span>
            <span role="cell">v1.0 · 2025.12.02</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function Process() {
  const renderProcessVisual = (stepNumber) => {
    switch (stepNumber) {
      case '01':
        return (
          <div className="journey-visual journey-visual--network" aria-hidden="true">
            <div className="journey-network">
              <div className="journey-network__option journey-network__option--filecoin">
                <span className="journey-network__type">STORAGE</span>
                <img src="/images/filecoin-logo.png" alt="" />
                <strong>Filecoin</strong>
                <small>분산 스토리지</small>
              </div>
              <div className="journey-network__route">
                <span />
                <strong>OR</strong>
                <span />
              </div>
              <div className="journey-network__option journey-network__option--aethir">
                <span className="journey-network__type">COMPUTE</span>
                <img src="/images/aethir-logo.png" alt="" />
                <strong>Aethir</strong>
                <small>GPU 클라우드</small>
              </div>
            </div>
            <div className="journey-network__status">
              <span>운용 목적에 맞는 인프라 선택</span>
              <strong>FIL · ATH</strong>
            </div>
          </div>
        );
      case '02':
        return (
          <div className="journey-visual journey-visual--liquidity" aria-hidden="true">
            <div className="journey-liquidity__summary">
              <div className="journey-liquidity__donut">
                <span>100%</span>
                <small>운용 현황</small>
              </div>
              <div className="journey-liquidity__total">
                <span>TOTAL LIQUIDITY</span>
                <strong>714K</strong>
                <small>FIL + ATH</small>
              </div>
            </div>
            <div className="journey-liquidity__rows">
              <div>
                <span>예치 가능</span>
                <strong>68%</strong>
                <i><b /></i>
              </div>
              <div>
                <span>운용 중</span>
                <strong>32%</strong>
                <i><b /></i>
              </div>
            </div>
            <div className="journey-liquidity__flow">
              <span>예치</span><i>→</i><span>운용</span><i>→</i><span>리워드</span>
            </div>
          </div>
        );
      case '03':
        return (
          <div className="journey-visual journey-visual--verify" aria-hidden="true">
            <div className="journey-verify__hero">
              <div className="journey-verify__shield"><span>✓</span></div>
              <div>
                <span>VERIFICATION</span>
                <strong>검증 완료</strong>
                <small>네트워크 데이터 확인</small>
              </div>
            </div>
            <ul className="journey-verify__list">
                <li>
                <i>01</i><strong>증명 데이터</strong><span>확인</span>
                </li>
                <li>
                <i>02</i><strong>보상 구조</strong><span>매핑</span>
                </li>
                <li>
                <i>03</i><strong>위험 고지</strong><span>안내</span>
                </li>
            </ul>
          </div>
        );
      default:
        return (
          <div className="journey-visual journey-visual--portfolio" aria-hidden="true">
            <div className="journey-portfolio__head">
              <div>
                <span>MY PORTFOLIO</span>
                <strong>자산 현황</strong>
              </div>
              <b>+12.8%</b>
            </div>
            <div className="journey-portfolio__chart">
              <i /><i /><i /><i /><i /><i />
              <span />
            </div>
            <div className="journey-portfolio__assets">
              <div>
                <img src="/images/filecoin-logo.png" alt="" />
                <span><small>STORAGE</small><strong>382K FIL</strong></span>
                <b>54%</b>
              </div>
              <div>
                <img src="/images/aethir-logo.png" alt="" />
                <span><small>COMPUTE</small><strong>1.18M ATH</strong></span>
                <b>46%</b>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <section className="section section--process" id="process">
      <div className="section__heading section__heading--compact">
        <span>SERVICE FLOW</span>
        <h2>메인에서 대시보드까지 이어지는 흐름</h2>
      </div>

      <div className="process-grid">
        {processSteps.map((step) => (
          <article className="process-card" key={step.number}>
            <div className="process-card__heading">
              <span>{step.number}</span>
              <h3>{step.title}</h3>
            </div>
            {renderProcessVisual(step.number)}
            <p>{step.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

function Notice() {
  return (
    <section className="notice" aria-labelledby="risk-notice-title">
      <div className="notice__copy">
        <span>RISK NOTICE</span>
        <h2 id="risk-notice-title">이용 전 반드시 확인해야 할 리스크 안내</h2>
        <p>
          가상자산 서비스는 시장 가격 변동, 네트워크 상태, 입출금 처리 조건에 따라 손실 또는
          이용 제한이 발생할 수 있습니다.
        </p>
      </div>
      <div className="notice__panel">
        <ul>
          <li>
            <strong>가격 변동성</strong>
            <span>시장 상황에 따라 자산 가치가 빠르게 변동될 수 있습니다.</span>
          </li>
          <li>
            <strong>네트워크 리스크</strong>
            <span>블록체인 네트워크 혼잡, 장애, 정책 변경이 처리 시간에 영향을 줄 수 있습니다.</span>
          </li>
          <li>
            <strong>확인 의무</strong>
            <span>상세 가이드, 고객확인제도, 위험 고지를 확인한 뒤 서비스를 이용해 주세요.</span>
          </li>
        </ul>
        <a href={`${serviceUrl}/policy/risk-notice`}>위험 고지 자세히 보기</a>
      </div>
    </section>
  );
}

function Faq() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [openItemId, setOpenItemId] = useState(faqGroups[0].items[0].id);

  const visibleGroups =
    selectedCategory === 'all'
      ? faqGroups
      : faqGroups.filter((group) => group.id === selectedCategory);

  const handleCategorySelect = (categoryId) => {
    const nextGroup =
      categoryId === 'all' ? faqGroups[0] : faqGroups.find((group) => group.id === categoryId);

    setSelectedCategory(categoryId);
    setOpenItemId(nextGroup?.items[0]?.id || '');
  };

  return (
    <section className="faq-section" id="faq" aria-labelledby="faq-title">
      <div className="faq-shell">
        <div className="faq-top">
          <div>
            <span>FAQ</span>
            <h2 id="faq-title">자주 묻는 질문</h2>
          </div>
        </div>

        <div className="faq-tabs" aria-label="FAQ categories">
          {faqCategories.map((category) => (
            <button
              className={selectedCategory === category.id ? 'is-active' : undefined}
              key={category.id}
              type="button"
              onClick={() => handleCategorySelect(category.id)}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="faq-content">
          {visibleGroups.map((group) => (
            <section className="faq-group" key={group.id} aria-labelledby={`faq-${group.id}`}>
              <h3 id={`faq-${group.id}`}>{group.title}</h3>
              <ul className="faq-list">
                {group.items.map((item) => {
                  const isOpen = openItemId === item.id;

                  return (
                    <li className={isOpen ? 'faq-item is-open' : 'faq-item'} key={item.id}>
                      <button
                        className="faq-item__question"
                        type="button"
                        aria-expanded={isOpen}
                        aria-controls={`${item.id}-answer`}
                        onClick={() => setOpenItemId(isOpen ? '' : item.id)}
                      >
                        <span>{item.question}</span>
                        <i aria-hidden="true" />
                      </button>
                      <div
                        className={isOpen ? 'faq-item__answer is-open' : 'faq-item__answer'}
                        id={`${item.id}-answer`}
                      >
                        <div className="faq-item__answer-inner">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}

function HomePage() {
  return (
    <main>
      <Hero />
      <Networks />
      <GuideSummary />
      <Process />
      <Notice />
    </main>
  );
}

function FaqPage() {
  return (
    <main className="faq-page">
      <Faq />
    </main>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__top">
          <img src="/images/filmountain_logo.png" alt="FilMountain" />

          <div className="site-footer__contact">
            <h4>Contact</h4>
            <p>
              <strong>T.</strong> 02-1844-3095 | <strong>FAX</strong> 02-2088-4655
            </p>
            <p>
              <strong>사업/제휴</strong> 02-569-2227
            </p>
            <p>
              <strong>메일</strong> allen@zetacube.net
            </p>
          </div>

          <div className="site-footer__locations">
            <h4>Locations</h4>
            <div className="location-grid">
              <address>
                <strong>본사/연구소</strong>
                경기도 부천시 소사구 양지로 237
                <br />
                광양프런티어밸리 5차 지식산업센터
                <br />
                1078, 1079호
              </address>
              <address>
                <strong>Show Room</strong>
                서울시 서초구 효령로 304
                <br />
                국제전자센터 3층 30호
              </address>
              <address>
                <strong>Data Center</strong>
                경기도 고양시 덕양구 항동동 391
                <br />
                DMC플렉스시청 A동 12층
              </address>
            </div>
          </div>
        </div>

        <nav className="site-footer__links" aria-label="Policy links">
          {footerLinks.map(([label, path, highlight]) => (
            <a
              className={highlight ? 'site-footer__link--highlight' : undefined}
              href={`${serviceUrl}${path}`}
              key={label}
            >
              {label}
            </a>
          ))}
        </nav>

        <p className="site-footer__copyright">© 2024 FILMOUNTAIN. All rights reserved.</p>
      </div>
    </footer>
  );
}

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const isFaqPage = currentPath === '/faq';

  useEffect(() => {
    const handlePopState = () => setCurrentPath(window.location.pathname);

    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    document.title = isFaqPage
      ? 'FAQ | FileMountain'
      : 'FileMountain | Digital Asset Infrastructure';
  }, [isFaqPage]);

  const navigate = (path) => {
    if (path === currentPath) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    window.history.pushState({}, '', path);
    setCurrentPath(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Header currentPath={currentPath} onNavigate={navigate} />
      {isFaqPage ? <FaqPage /> : <HomePage />}
      <Footer />
    </div>
  );
}

export default App;
